import BaseApi from './base/BaseApi';

export default class extends BaseApi {
  static entityName = 'teams';
}
